import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'POSTCHAIN/GET';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetPostChainDetail(client, { payload: pci }) {
  try {
    const response = yield client.post('/postChain/get', { data: { pci } });
    yield put(actions.loadSuccess(response.result));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
